import { useErpCompany } from "@/common/hooks/use-erp-company";

import { Strategy } from "../marketplace.flow";

class TrialStrategy implements Strategy {
  public canInteract() {
    return false;
  }

  public showCallToAction() {
    return true;
  }

  public getcompanyGetter() {
    return useErpCompany;
  }
}

export { TrialStrategy };
